export var ADDON_ID = 'storybook/interactions';
export var PANEL_ID = "".concat(ADDON_ID, "/panel");